import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";

import { Resource } from "@impulse/sdp-shared-models";

import { PolicyWizardService } from "../policy-wizard.service";
import { TranslateService } from "../../../../common/translate/translate.service";
import { SnackbarService } from "../../../../common/snackbar/snackbar.service";
import { AbstractWizardStepComponent } from "app/administrative/wizard-dialog/abstract-wizard-step.component";
import { PolicyAccessSelectComponent } from "../policy-access-select/policy-access-select.component";


@Component({
	templateUrl: "./policy-resource-select.component.html"
})
export class PolicyResourceSelectComponent extends AbstractWizardStepComponent<void> implements OnInit {
	public form!: FormGroup;
	public resources: Resource[] = [];
	public dataLoaded = false;

	constructor(
		private service: PolicyWizardService,
		private formBuilder: FormBuilder,
		private translateService: TranslateService,
		private snackbarService: SnackbarService
	) {
		super();
		this.form = this.formBuilder.group({
			resource: [
				"",
				Validators.required
			]
		});
	}

	public async ngOnInit() {
		try {
			this.resources = await this.service.getResourcesMissingPolicies();
		} catch (e) {
			this.snackbarService.open(this.translateService.translate(e));
		} finally {
			this.dataLoaded = true;
		}
	}

	public closeDialog() {
		this.service.closeDialog();
	}

	public get title() {
		return "policy.wizard.applicationSelect.title";
	}

	public get description() {
		return "policy.wizard.applicationSelect.info";
	}

	public get nextStep() {
		return PolicyAccessSelectComponent;
	}

	public get previousStep(): AbstractWizardStepComponent.ConstructorFunction<void> | undefined {
		return undefined;
	}

	public get isFormValid(): boolean {
		return !!this.form && this.form.valid;
	}
	public get showProgressBar(): boolean {
		return !this.dataLoaded;
	}
	public performNext(): void {
		this.service.resource = <Resource>this.form.getRawValue().resource;
	}
	public performPrevious(): void {
		// NOOP
	}
}
